export default "__VITE_ASSET__x7yV_6Eq__"